import styles from "./Monitoring.module.css";
import { useState, useEffect, useCallback } from "react";
import AGTable from "../../components/AGTable/AGTable";
import { Spinner } from "react-bootstrap";
import { getControlPanelStatusPage } from "../../api/portalApi";

const Monitoring = (props) => {
    // Data States
    const [monitoringData, setMonitoringData] = useState();

    // UI States
    const [loading, setLoading] = useState(false);

    // Fetch Data from API
    const fetchData = useCallback( async() => {
        setLoading(true);
        try {
            const res = await getControlPanelStatusPage();
            setMonitoringData(res.data?.data || res?.data);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }

    }, []);

    useEffect(() => { 
        fetchData();
    }, [fetchData]);

    let flattenedData;
    if (monitoringData){
        flattenedData = monitoringData?.map(obj =>
            Object.fromEntries(
                Object.entries(obj).map(([key, value]) => [
                    key,
                    Array.isArray(value) ? value.join(", ") : value
                ])
            )
        );
    }
    const conditionalRules = [
        {
            column: ["status"],
            rules: {
                "cell-success": params => params.value === "Operational",
                "cell-fail": params => params.value === "Outage"
            }
        }
    ]
    return (
        <div className={styles.Monitoring}> 
            <h4>Platform Status Page</h4>
            {flattenedData && <AGTable data={flattenedData} conditionalRules={conditionalRules} fileName="monitoring.csv" showSelect={true}/>}
            {loading && <div className={styles.spinnerContainer}>
                <Spinner/>
            </div>}
        </div>
    )
};

export default Monitoring;